import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import Modal from "components/Modal/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import ModalFooterLeft from "components/Modal/ModalFooterLeft";
import ModalFooterRight from "components/Modal/ModalFooterRight";
import Button from "components/Button/Button";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import TextField from "components/FormFields/TextField";
import { acceptFarmOwnership, declineFarmOwnership } from "../_actions";

const FarmOwnershipNominationResponseModal = ({ nomination, close, acceptFarmOwnership, declineFarmOwnership }) => {
    return (
        <Form initialValues={{ ...nomination, nominatedBy: nomination.invitedBy.userFullName }} onSubmit={submit(acceptFarmOwnership, declineFarmOwnership, close)}>
            {({ form, values, handleSubmit, submitting, submitError, dirtySinceLastSubmit }) => {
                const error = (values && values.error) || (!dirtySinceLastSubmit && submitError);
                const nominatedBy =
                    nomination.invitedBy.userFullName === nomination.invitedBy.accountName ? (
                        <b>{nomination.invitedBy.userFullName}</b>
                    ) : (
                        <>
                            <b>{nomination.invitedBy.userFullName}</b> on behalf of <b>{nomination.invitedBy.accountName}</b>
                        </>
                    );
                const info = (
                    <span>
                        {nominatedBy} has nominated you as an <b>{nomination.role}</b> of the <b>{nomination.farmName}</b> farm. Review the nomination details and respond.
                    </span>
                );
                return (
                    <form onSubmit={handleSubmit}>
                        <Modal title="Farm ownership nomination" close={close} submitting={submitting} fluid>
                            <ModalBody info={info} error={error}>
                                <Field name="id" type="hidden" component="input" />
                                <Grid>
                                    <GridCell className="u-lg-width1of2">
                                        <Field name="farmName" label="Requested farm" readOnly component={TextField} />
                                    </GridCell>
                                    <GridCell className="u-lg-width1of2">
                                        <Field name="farmAddress" label="Farm address" readOnly component={TextField} />
                                    </GridCell>
                                    <GridCell className="u-lg-width1of2">
                                        <Field name="nominatedBy" label="Nominated by" readOnly component={TextField} />
                                    </GridCell>
                                    <GridCell className="u-mt-md">
                                        <h3>
                                            If you <u>accept</u> ownership...
                                        </h3>
                                        <ul className="disc">
                                            <li>
                                                You accept ownership of the <b>{nomination.farmName}</b> farm
                                            </li>
                                            <li>As the farm account owner, you have full control over who can view or edit your information</li>
                                        </ul>
                                    </GridCell>
                                </Grid>
                            </ModalBody>
                            <ModalFooter>
                                <ModalFooterLeft>
                                    <Button id="cancel" onClick={close} secondary disabled={submitting}>
                                        Cancel
                                    </Button>
                                    <Button id="decline" submit onClick={() => form.change("accepted", false)} tertiary disabled={submitting}>
                                        Decline
                                    </Button>
                                </ModalFooterLeft>
                                <ModalFooterRight>
                                    <Button id="accept" submit onClick={() => form.change("accepted", true)} primary disabled={submitting}>
                                        Accept
                                    </Button>
                                </ModalFooterRight>
                            </ModalFooter>
                        </Modal>
                    </form>
                );
            }}
        </Form>
    );
};

const submit = (acceptFarmOwnership, declineFarmOwnership, closeModal) => async (viewModel) => {
    try {
        if (viewModel.accepted) {
            await acceptFarmOwnership(viewModel);
        } else {
            await declineFarmOwnership(viewModel);
        }
        closeModal();
    } catch (error) {
        return { [FORM_ERROR]: error };
    }
};

export default compose(withAppContext, withActions({ acceptFarmOwnership, declineFarmOwnership }))(FarmOwnershipNominationResponseModal);
